export default __webpack_public_path__ + "static/media/menu.f6c40b28.svg";